export const USER_QUESTIONS_REFRESH_EVENT = "composer-user-questions-refresh";
export const USER_QUESTIONS_UPDATED_EVENT = "composer-user-questions-updated";

export const notifyUserQuestionsUpdated = () => {
  try {
    window.dispatchEvent(new CustomEvent(USER_QUESTIONS_UPDATED_EVENT));
  } catch (_) {
    /* no-op */
  }
};
